import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MultipleStopOutlinedIcon from "@mui/icons-material/MultipleStopOutlined";

import FormField from "./FormField";

export default function FieldsSection({
  title,
  fields,
  fullWidth,
  disabledForm,
  onReorder,
  onTitleClick,
}) {
  const md = fullWidth ? 12 : 4;

  if (fields.length === 0) {
    return null;
  }

  return (
    <Card sx={{ overflow: "visible" }}>
      <CardContent>
        <Box mt={-1} mb={1} display="flex" justifyContent="space-between" alignItems="center">
          <Typography
            component={onTitleClick ? "button" : "div"}
            fontWeight={500}
            fontSize={18}
            onClick={onTitleClick}
            type={onTitleClick ? "button" : undefined}
            aria-haspopup={onTitleClick ? "dialog" : undefined}
            sx={
              onTitleClick
                ? {
                    background: "none",
                    border: 0,
                    color: "inherit",
                    cursor: "pointer",
                    m: 0,
                    p: 0,
                    textAlign: "left",
                  }
                : undefined
            }
          >
            {title}
          </Typography>
          {onReorder && (
            <Tooltip arrow title="Reorder fields">
              <IconButton onClick={onReorder}>
                <MultipleStopOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
        <Grid container spacing={1.5}>
          {fields.map(({ id, params, type, gridProps }) => (
            <Grid key={id} size={{ xs: 12, md: gridProps?.sm || md }}>
              <FormField id={id} params={params} type={type} disabled={disabledForm} />
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
}
